import Vue from 'vue';
import SkyGallery from './sky-gallery';

Vue.component('sky-gallery', SkyGallery);

export default SkyGallery;



// WEBPACK FOOTER //
// ./scripts/sky-gallery/index.js